<template lang="pug">
.m-card
  .m-card-header(:id="'heading-bs-' + id" :data-bs-target="'#collapse-bs-' + id" :aria-controls="'collapse-bs-' + id" data-bs-toggle='collapse' role='button' aria-expanded='false')
    .group
      .league-name {{ $tc("m.BT_BS", 1) }}
  .m-card-body.collapse.show(:id="'collapse-bs-' + id" :aria-labelledby="'heading-bs-' + id" aria-expanded='false')
    .m-card-item(:class="{ 'live' : marketType == 3 }")
      .m-card-wrap
        .odds-wrapper(v-if="mode == 0 || mode == 1")
          .m-label-wrap
            .m-label F.T
          .odds-group
            template(v-if="moreItems['bso']['BOTH'] && moreItems['bso']['BOTH'][5] != 0 && moreItems['bso']['BOTH'][5] != ''")
              OddsItem.col(:odds="moreItems['bso']['BOTH']" idx=5 :typ="oddsType" dataType="3" :label="$t('m.BT_BOTH')")
            template(v-else)
              OddsDisabled.col
            template(v-if="moreItems['bso']['ONE'] && moreItems['bso']['ONE'][5] != 0 && moreItems['bso']['ONE'][5] != ''")
              OddsItem.col(:odds="moreItems['bso']['ONE']" idx=5 :typ="oddsType" dataType="3" :label="$t('m.BT_ONE')")
            template(v-else)
              OddsDisabled.col
            template(v-if="moreItems['bso']['NG'] && moreItems['bso']['NG'][5] != 0 && moreItems['bso']['NG'][5] != ''")
              OddsItem.col(:odds="moreItems['bso']['NG']" idx=5 :typ="oddsType" dataType="3" :label="$t('m.BT_NG')")
            template(v-else)
              OddsDisabled.col


//- .card.market-card
//-   .card-header.bg-more-head.collapse-more(
//-     :id="'heading-bs-' + id"
//-     data-toggle='collapse'
//-     :data-target="'#collapse-bs-' + id"
//-     :aria-controls="'collapse-bs-' + id"
//-     aria-expanded=true
//-   )
//-     .flex-grow-1.text-ellipsis.text-uppercase.mr-2 {{ $tc("m.BT_BS", 1) }}
//-   .collapse.show(
//-     :aria-labelledby="'heading-bs-' + id"
//-     :id="'collapse-bs-' + id"
//-   )
//-     .card-body.p-0
//-       .market-card-content
//-         .normal(v-if="mode == 0 || mode == 1")
//-           .normal-title {{ $t("ui.full_time") }}
//-           .normal-odd-area
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.BT_BOTH") }}
//-               template(v-if="moreItems['bso']['BOTH'] && moreItems['bso']['BOTH'][5] != 0 && moreItems['bso']['BOTH'][5] != ''")
//-                 OddsItem(:odds="moreItems['bso']['BOTH']" idx=5 :typ="oddsType" dataType="3" :details="moreItems")
//-               template(v-else)
//-                 OddsDisabled
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.BT_ONE") }}
//-               template(v-if="moreItems['bso']['ONE'] && moreItems['bso']['ONE'][5] != 0 && moreItems['bso']['ONE'][5] != ''")
//-                 OddsItem(:odds="moreItems['bso']['ONE']" idx=5 :typ="oddsType" dataType="3" :details="moreItems")
//-               template(v-else)
//-                 OddsDisabled
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.BT_NG") }}
//-               template(v-if="moreItems['bso']['NG'] && moreItems['bso']['NG'][5] != 0 && moreItems['bso']['NG'][5] != ''")
//-                 OddsItem(:odds="moreItems['bso']['NG']" idx=5 :typ="oddsType" dataType="3" :details="moreItems")
//-               template(v-else)
//-                 OddsDisabled
</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    OddsItem,
    OddsDisabled
  },
  mixins: [mixinHDPOUOdds],
  props: {
    mode: {
      type: Number
    }
  }
}
</script>
